import { render, staticRenderFns } from "./examples.vue?vue&type=template&id=38ba6b6a&"
import script from "./examples.vue?vue&type=script&lang=js&"
export * from "./examples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports